import { withAsyncLoading } from '../../../Components/Templates/Loading/AsyncPageLoading/withAsyncPageLoading';

const LoadableLogin = withAsyncLoading(async () =>
    import('./LoginPage').then((res) => res.LoginPage)
);

export { LoadableLogin };
